import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';
import { InitialService } from './initial.service';

@Injectable({
  providedIn: 'root',
})
export class RouteEtaService {
  private readonly AVG_CITY_SPEED_KMPH = 35;
  private readonly initialService = inject(InitialService);

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  /**
   * Equivalent to Android:
   * SphericalUtil.computeLength(path)
   */
  computeDistanceMeters(points: any[]): number {
    if (
      !points ||
      points.length < 2 ||
      !this.initialService.googleMapsReady()
    ) {
      return 0;
    }

    try {
      const path = points.map(p => new google.maps.LatLng(p.lat, p.lng));
      return google.maps.geometry.spherical.computeLength(path);
    } catch (e) {
      console.warn('computeDistanceMeters failed', e);
      return 0;
    }
  }

  /**
   * Equivalent to:
   * distanceMeters / speedMps
   */
  calculateEtaFromAvgSpeed(distanceMeters: number): number {
    const speedMps = (this.AVG_CITY_SPEED_KMPH * 1000) / 3600;
    return Math.floor(distanceMeters / speedMps); // seconds
  }

  /**
   * Kotlin let{} equivalent
   */
  getDistanceAndEta(remainingRoutePolyline?: { points: any[] }): {
    distance: number;
    time: number;
  } {
    if (!remainingRoutePolyline?.points?.length) {
      return { distance: 0, time: 0 };
    }

    const distance = this.computeDistanceMeters(remainingRoutePolyline.points);

    const time = this.calculateEtaFromAvgSpeed(distance);

    return { distance, time };
  }
}
